import { Component, OnInit } from '@angular/core';
import { ModalService } from 'src/app/services/modal/modal.service';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

export const ModalRgpd = 'rgpd';

@Component({
    selector: 'app-rgpd-modal',
    templateUrl: './rgpd-modal.component.html',
    styleUrls: ['./rgpd-modal.component.scss']
})
export class RgpdModalComponent implements OnInit {
    modalOpen = false;
    faTimes = faTimes;

    constructor(private modalService: ModalService) {}

    ngOnInit() {
        this.modalService.register(ModalRgpd, this);
    }

    // Mandatory para Modal Service
    show() {
        this.modalOpen = true;
    }

    // Mandatory para Modal Service
    hide() {
        this.modalOpen = false;
    }

    onCancel() {}

    cancel() {
        this.onCancel();
        this.modalOpen = false;
    }

    showTarteaucitronPopIn() {
        return window.location + '#tarteaucitron';
    }
}
